<template>
	<div>
		<template v-if="noData == 0">
      <div class="card-list-wrapper" :class="{'web-filter-gray': pageInfo && pageInfo.webGray}" :style="[topStyle]">
        <div class="card-list-wrapper" v-for="(item, index) in pages" :key="index">
          <!-- 轮播图 -->
          <Banner v-if="item.type === 'banner'" :facade="item.facade" :content="item.content" @go-next="goNext"></Banner>
          <!-- 表单 -->
          <Form v-if="item.type === 'form'" :facade="item.facade" :content="item.content"></Form>
          <!-- 短视频 -->
          <div v-if="item.type === 'video' && item.content" style="width: 100%;height: 210px;position: relative;" :style="{height: (item.content.source && item.facade.showHeight) ? (item.facade.showHeight + 'px') : 215 + 'px'}">
            <video
              style="width: 100%;height: 210px;"
              :id="'myVideo_' + item.id"
              controls
              controlslist="nodownload nofullscreen noremoteplayback"
              disablePictureInPicture
              :style="{height: (item.content.source && item.facade.showHeight) ? (item.facade.showHeight + 'px') : 215 + 'px'}"
              :src="item.content.video"
              :poster="item.content.cover || `${item.content.video}?x-oss-process=video/snapshot,t_1,m_fast`"
              crossorigin="anonymous"
              :loop="item.content.loop ? true : false"
              :muted="item.content.muted ? true : false"
            ></video>
            <VideoAdd v-if="item.facade && ['left', 'center', 'right'].includes(item.facade.styleAlign)" :facade="item.facade" :content="item.content" @go-next="goNext"></VideoAdd>
          </div>
          <!-- 富文本 -->
          <div v-if="item.type === 'richText'">
            <div
              style="width: 100%;"
              :style="{ 'background-color': item.facade.background_color}"
            >
            <div v-html="item.content && item.content.html" :style="{ 'padding-left': item.facade.padding_zy + 'px', 'padding-right': item.facade.padding_zy + 'px'}" />
            </div>
          </div>
          <!-- 公告 -->
          <Notice v-if="item.type === 'notice'" :facade="item.facade" :content="item.content" @go-next="goNext"></Notice>
          <!-- 图片 -->
          <Picture v-if="item.type === 'picture'" :facade="item.facade" :content="item.content" @go-next="goNext"></Picture>
          <!-- 标题栏 -->
          <Title v-if="item.type === 'title'" :facade="item.facade" :content="item.content" @go-next="goNext"></Title>
          <!-- 魔方宫格 -->
          <Rubik v-if="item.type === 'rubik'" :facade="item.facade" :content="item.content" @go-next="goNext"></Rubik>
          <!-- 辅助线 -->
          <div class="separate" v-if="item.type === 'separate'" :style="{ paddingTop: item.facade.margin + 'px', paddingBottom: item.facade.margin + 'px' }">
            <div
              :style="{ borderTopWidth: '1px', borderTopStyle: item.content.style, borderTopColor: item.facade.fill_color }">
            </div>
          </div>
          <!-- 辅助空白 -->
          <div class="blank" v-if="item.type === 'blank'"
            :style="{ height: item.facade.height + 'px', backgroundColor: item.facade.background_color }">
          </div>
        </div>
      </div>
      <div style="height: 10px;"></div>
      <!-- 页面弹窗 -->
      <page-popup
        v-if="pageInfo.pagePopup && pageInfo.pagePopup.enabled && pageInfo.pagePopup.data && pageInfo.pagePopup.data.length"
        :facade="pageInfo.pagePopup.facade"
        :content="pageInfo.pagePopup"
        @go-next="goNext"
      />
    </template>
    <template v-if="noData == 1">
      <div class="no-box">
        <div class="no-box">
          <img class="no-img" src="https://zk-micro.oss-cn-hangzhou.aliyuncs.com/wfw_none_404.png" alt="">
          <div class="no-text">当前页面无法访问</div>
          <div class="no-futext">该页面已过期或被删除~</div>
        </div>
      </div>
    </template>
	</div>
</template>

<script>
import { Toast } from 'vant';
import Banner from './components/banner.vue';
import Form from './components/form.vue';
import VideoAdd from './components/videoAdd.vue';
import Notice from './components/notice.vue';
import Picture from './components/picture.vue';
import Title from './components/title.vue';
import Rubik from './components/rubik.vue';
import pagePopup from './components/pagePopup.vue';

export default {
  components: {
    Banner,
    Form,
    VideoAdd,
    Notice,
    Picture,
    Title,
    Rubik,
    pagePopup,
  },
  data() {
    return {
      noData: -1,
      id: '',
      topAdPic: 0,
      pageInfo: {},
      pages: []
    }
  },
  computed: {
    topStyle() {
      let style = {
        'padding-top': this.topAdPic + 'px'
      }
      let {background, backgroundColorRight, backgroundUrl, bgImgType, bgImgRepeat} = this.pageInfo
      if (this.pageInfo && this.pageInfo.backgroundStyle == 1) {
        style = {
          'padding-top': this.topAdPic + 'px',
          background: `linear-gradient(to bottom , ${background}, ${backgroundColorRight})`
        }
      } else if (this.pageInfo && this.pageInfo.backgroundStyle == 2) {
        style = {
          'padding-top': this.topAdPic + 'px',
          background: "none"
        }
        // if (!this.isLoading) {
          style.backgroundImage = `url(${backgroundUrl})`
          style.backgroundSize = bgImgType || 'cover'
          style.backgroundRepeat = bgImgRepeat ? 'repeat' : 'no-repeat'
        // }
      } else {
        style = {
          'padding-top': this.topAdPic + 'px',
          background: background || '#ffffff'
        }
        if (!(this.pageInfo && this.pageInfo.background)) style.height = 100 + 'vh'
      }
      return style
    }
  },
  mounted() {
    this.id = this.$route.params.id
    console.log(this.id)
    this.getData()
  },
  watch: {
    $route(to, from) {
      console.log(to, from, 'to and from')
      if (to.params.id && from.params.id && to.params.id != from.params.id) {
        this.noData = -1
        this.getData()
      }
    }
  },
  methods: {
    getData() {
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加载中...',
        loadingType: 'spinner',
      });
      this.$store.dispatch('GET_H5DETAIL_PAGE', {
        id: this.id
      }).then(res => {
        console.log(res, '112233')
        Toast.clear();
        if (res && res.status === '00000') {
          if (res.data && res.data.companyId) {
            localStorage.setItem('companyId', res.data.companyId)
          }
          if (res.data && res.data.pagePopup) {
            res.data.pagePopup = JSON.parse(res.data.pagePopup)
            res.data.pagePopup.data.forEach(item => {
              if (item && item.link && item.link.selectArr) item.link.selectArr = JSON.parse(item.link.selectArr)
            })
            res.data.pagePopup.facade = JSON.parse(res.data.pagePopup.facade)
          }
          if (res.data && res.data.pages && res.data.pages.length) {
            // 处理装修数据
            let screenWidth = window.innerWidth

            res.data.pages.forEach(item => {
              item.content = JSON.parse(item.content)
              
              if (item.content) {
                // 重置selectArr格式
                if (item.content.link && item.content.link.selectArr) {
                  item.content.link.selectArr = JSON.parse(item.content.link.selectArr)
                }
                if (item.content.data && item.content.data.length) {
                  item.content.data.forEach( _item => {
                    if (_item.link && _item.link.selectArr) _item.link.selectArr = JSON.parse(_item.link.selectArr)
                    if (item.type === 'picture' && _item.hotZoneList && _item.hotZoneList.length) {
                      // 当前图片的宽高
                      let imgWidth = _item.imgWidth * 1;
                      let imgHeight = _item.imgHeight * 1;
                      let curWidth = screenWidth - item.facade.padding_zy * 2;
                      let curHeight = (_item.imgHeight * curWidth) / imgWidth;
                      let _hotarea = JSON.parse(JSON.stringify(_item.hotZoneList));
                      _hotarea.map((val) => {
                        let params = JSON.parse(JSON.stringify(val));
                        console.log('params:', {
                          params,
                          width: params.width,
                          height: params.height,
                          rotH: (params.height * curHeight) / imgHeight,
                        });
                        val.width = (params.width * curWidth) / imgWidth; // 热区长
                        val.height = (params.height * curHeight) / imgHeight; // 热区高
                        val.is_left = (params.is_left * curWidth) / imgWidth;
                        val.is_top = (params.is_top * curHeight) / imgHeight;
                        // console.log('当前热区的宽高:', {val, width: val.width, height: val.height})
                      });
                      _item.hotZoneList = _hotarea;

                      _item.hotZoneList.map(val => {
                        if (val.link && val.link.selectArr) val.link.selectArr = JSON.parse(val.link.selectArr)
                      })
                    }
                  })
                }
              }

              item.facade = JSON.parse(item.facade)

              // 格式化表单 默认数据
              if (item && item.type === 'form' && item.content && item.content.form && item.content.form.list) {
                item.content.form.list.forEach((_item) => {
                  _item.defaultData = _item.defaultData ? JSON.parse(_item.defaultData) : {};
                  if (_item.defaultData) {
                    _item.value = '';
                    switch (_item.contentType) {
                      case 3: // 时间
                        let year = new Date().getFullYear();
                        let month = new Date().getMonth() + 1 < 10 ? `0${new Date().getMonth() + 1}` : new Date().getMonth() + 1;
                        let day = new Date().getDate() < 10 ? `0${new Date().getDate()}` : new Date().getDate();
                        _item.value = _item.defaultData.defaultRadio === 2 ? (year + '-' + month + '-' + day) : (_item.defaultData.defaultRadio === 3 ? _item.defaultData.freeTime.slice(0, 10) : '');
                        console.log(_item.value, _item.defaultData.freeTime.slice(0, 10), '112233445566=======')
                        break;
                      case 4: // 地区
                        let arr = _item.defaultData.provinceShow ? [_item.defaultData.defaultProvince] : [];
                        if (_item.defaultData.conditRadio === 2 && _item.defaultData.cityShow)
                          arr = arr.concat(_item.defaultData.defaultCity);
                        if (_item.defaultData.conditRadio === 3 && _item.defaultData.areaShow)
                          arr = [_item.defaultData.defaultProvince, _item.defaultData.defaultCity, _item.defaultData.defaultArea];
                        _item.value = '';
                        break;
                      case 1: // 图片
                        _item.value = [];
                        break;
                      case 8: // 多选
                        _item.value = [];
                        _item.otherValue = '';
                        break;
                      case 7: // 单选
                        _item.otherValue = '';
                        break;
                      case 10: // 评分
                        _item.value = 0;
                        break;
                    }
                  }
                })
              }
            })

            this.pages = res.data.pages
            console.log(this.pages, '获取装修组件')
          }
          this.pageInfo = res && res.data || {}
          let title = res && res.data && res.data.title || 'H5页面'
          this.dynamicStateTitle(title)
          this.noData = 0
        } else {
          this.noData = 1
        }
      }).catch(() => {
        Toast.clear();
        this.noData = 1
      })
    },
    // 更改页面标题
    dynamicStateTitle(title) {
      setTimeout(function () {
        document.title = title;
        var iframe = document.createElement("iframe");
        iframe.style.visibility = "hidden";//解决在过渡过程中会出现黑斑，实现无缝过渡刷新
        iframe.style.width = "1px";
        iframe.style.height = "1px";
        iframe.onload = function () {
          setTimeout(function () {
            document.body.removeChild(iframe);
          }, 0);
        };
        document.body.appendChild(iframe);
      }, 0);
    },
    // jumpTo() {
    //   window.open('http://www.baidu.com')
    // },
    goNext(item) {
      console.log('跳转啦：', item, this.$route.query)
      if (item.miniHref) {
        if (item.jumpType == "columnDetail" && this.$route.query.attractId) {
          let href = item.miniHref
          let id = this.$route.query.attractId
          if (item.miniHref.indexOf('attractId=') !== -1) {
            href = href.replace(/(attractId=)\d+/, `$1${id}`)
          } else {
            href = href + `&attractId=${id}`
          }
          console.log('原', item.miniHref)
          console.log('id', id)
          console.log('href', href)
          // return
          this.goTominiapp(href)
        } else if (item.jumpType == 'webview') {
          location.href = item.miniHref
        } else {
          this.goTominiapp(item.miniHref)
        }
      }
    },
    goTominiapp(url) {
      let arr = url.split('?')
      let params = {
        envVersion: 'release'
      }
      if (arr.length && arr[0]) {
        params.path = arr[0]
      }
      if (arr.length && arr[1]) {
        // params.query = encodeURIComponent(arr[1])
        params.query = this.disposeUrl(arr[1])
      }
      console.log(params)
      // return
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '跳转中...',
        loadingType: 'spinner',
      });
      this.$store.dispatch('POST_SCHEME_CODE', params).then(res => {
        Toast.clear();
        console.log(res, '112233')
        if (res && res.status && res.data) {
          location.href = res.data
        } else {
          Toast.fail(res.message || '跳转出错啦！')
        }
      })
    },
    disposeUrl(url) {
      console.log(url)
      let urlArr = url.split('&')
      let resultArr = []
      if (urlArr.length) {
        urlArr.forEach(item => {
          if (/[\u4e00-\u9fa5]/.test(item)) {
            item = item.replace(/=.+/, '') + '='
            // let reg = /[\u4e00-\u9fa5]/g;
            // let arr = item.match(reg)
            // let star = 0
            // let end = 0
            // for (let i = 0; i < item.length; i++) {
            //   if (item[i] == arr[0]) {
            //     star = i
            //     break;
            //   }
            // }
            // for (let i = item.length - 1; i >= 0; i--) {
            //   if (item[i] == arr[arr.length - 1]) {
            //     end = i
            //     break;
            //   }
            // }
            // let str = ''
            // item = item.substring(0, star) + str + item.substring(end + 1)
          }
          resultArr.push(item)
        })
        return resultArr.join('&')
      }
      return url
    }
  },
}
</script>

<style lang="scss" scoped>
.card-list-wrapper {
  width: 100%;
  height: 100%;
}

.web-filter-gray {
  filter: grayscale(.95);
  -webkit-filter: grayscale(.95);
}

.no-box {
  width: 100%;
  margin-top: r(100);
  display: flex;
  flex-direction: column;
  align-items: center;

  .no-img{
    width: r(180);
    height: r(143);
    margin-bottom: r(10);
  }

  .no-text {
    font-size: 18px;
    color: #333333;
    font-weight: bold;
  }

  .no-futext {

    font-size: 12px;
    color: #666;
  }
}
</style>
